import { useState, useEffect } from 'react';
import {isMobile} from 'react-device-detect';

const useMobileCheck = (): boolean => {
  const [isMobileDevice, setIsMobileDevice] = useState(isMobile);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(isMobileDevice);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobileDevice;
};

export default useMobileCheck;
